<template>
    <div class="event d-flex p-1 bg-lightest relative border-light ">
        <div class="image radius-normal bg-lighter">
            <img v-if="image" :src="image">
        </div>

        <div class="info mx-5 my-3 flex-all">
            <div class="d-flex">
                <h4 v-if="product" class="bold">{{ product.name }}</h4>
                <!-- <div class="pointer color-1 bold ml-auto" @click="openAddReservationModal">Edit</div> -->
            </div>

            <h5>{{ brand }}</h5>

            <ul class="settings d-flex justify-content-between mt-5 bold">
                <li>
                    <div class="fs-small normal">Date</div>
                    {{ dates['start_date'] }}

                    <span v-if="dates['start_date'] != dates['end_date']">
                        to {{ dates['end_date'] }}
                    </span>
                </li>
                <li>
                    <div class="fs-small normal">Time</div>
                    {{ dates['start_time'] }} - {{ dates['end_time'] }}
                </li>
                <li v-if="product">
                    <div class="fs-small normal">Departure location</div>
                    {{ product.locationCompleted.name }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        data: function () {
            return {
                form: {},
            }
        },
        created: function() {
            if (this.getClonedReservation) {
                this.form = JSON.parse(JSON.stringify(this.getClonedReservation));
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'account',
            ]),
            brand: function() {
                let brand = '-';

                if (this.account.supplier && this.account.supplier.brand !== undefined) {
                    brand = this.account.supplier.brand;
                }
                else if (this.account.agent && this.account.agent.brand !== undefined) {
                    brand = this.account.agent.brand;
                }

                return brand;
            },
            product: function() {
                return this.form.event.products;
            },
            image: function() {
                return (this.product !== undefined && this.product.imageLogo) ? this.product.imageLogo : null;
            },
            dates: function() {
                var s = moment(this.form.event.start);
                var e = moment(this.form.event.end);

                return {
                    start_date: this.formatDate(s),
                    start_time: this.formatTime(s),
                    end_date: this.formatDate(e),
                    end_time: this.formatTime(e),
                };
            },
        },
        methods: {
            ...mapActions([
                'openModal',
            ]),
            openAddReservationModal: function() {
                this.openModal('ReservationAdd');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .event {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;

        .image {
            width: 165px;
            height: 165px;
            overflow: hidden;

            > img {
                width: 165px;
                max-height: 165px;
            }
        }

        .logo {
            position: absolute;
            top: 0.5rem;
            right: 0.5rem;
        }
    }
</style>



// WEBPACK FOOTER //
// BasicData.vue?6fb15402